import { RouteConfig } from "vue-router";

export const REmployerServicesBrowse: RouteConfig = {
  path: "",
  name: "EmployerServicesBrowse",
  component: () =>
    import(
      /* webpackChunkName: "employer-services-browse" */
      "./VEmployerServicesBrowse.vue"
    ),
  meta: {
    title: "Services",
    legend: "Follow up on visa applications and start new ones.",
    icon: "briefcase-outline",
    childLabel: "Roles",
  },
};
